
define('ldsh!common/templates/alert_view', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="md__notification__header flex align-center gap-12">\n\n    ';
 if (success) { ;
__p += '\n        <span class="ri-checkbox-circle-line"></span>\n        ';
 } else { ;
__p += '\n            <span class="ri-close-circle-line"></span>\n            ';
 } ;
__p += '\n\n                <h2 class="md__notification__title">\n                    ';
 if (escapeMessage) { ;
__p += '\n                        ' +
__e( message ) +
'\n                            ';
 } else {;
__p += '\n                                ' +
((__t = ( message )) == null ? '' : __t) +
'\n                                    ';
 } ;
__p += '\n                </h2>\n\n                ';
 if (!autoHide && !persist) { ;
__p += '\n                    <div class="mt45">\n                        <button class="ed-btn ed-btn-small ed-close-alert ed-btn-secondary-flat i18n"\n                            data-i18n="alertView.common.close"></button>\n                    </div>\n                    ';
 } ;
__p += '\n</div>';

}
return __p
};});

